import { render, staticRenderFns } from "./InquiryLetterLabor.vue?vue&type=template&id=3c8b0710&scoped=true"
import script from "./InquiryLetterLabor.vue?vue&type=script&lang=js"
export * from "./InquiryLetterLabor.vue?vue&type=script&lang=js"
import style0 from "./InquiryLetterLabor.vue?vue&type=style&index=0&id=3c8b0710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8b0710",
  null
  
)

export default component.exports